<template>
  <scout-form
    :is-modified="!!value"
    :half="half"
    label="送信回数"
  >
    <input
      :value="value"
      class="boss-input boss-send-count"
      type="number"
      :max="Number.MAX_SAFE_INTEGER"
      min="0"
      data-test="text-box"
      @keypress="onlyNumberInRange($event)"
      @input="$emit('input', Number($event.target.value) || null)"
    >
    <span>回</span>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    ScoutForm
  },
  mixins: [eventValidations],
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    half: {
      default: false,
      type: Boolean
    }
  }
}
</script>
